export enum BooleanChoice {
  Yes = 'Yes',
  No = 'No',
}

export const booleanToBooleanChoice = (boolean: boolean | null) => {
  if (typeof boolean !== 'boolean') {
    return null;
  }

  return boolean ? BooleanChoice.Yes : BooleanChoice.No;
};

export const booleanChoiceToBoolean = (booleanChoice: BooleanChoice | null) =>
  booleanChoice === BooleanChoice.Yes;
